export const PERMS = {
    READ: 'report_invoicing_summary.read',
}
